var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"subList"},[_c('data-list',_vm._g(_vm._b({attrs:{"data":_vm.subData,"table-style":{ name: 'mixture' }}},'data-list',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }